import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { getErrorMessage } from 'Douleutaras/redux/getErrorMessage';

const FF_ENDPOINT = 'api/public/site-feature-flags';

export interface FeatureFlags {
  klarnaPromotionBannerEnabled: boolean;
  useSalesforceChat: boolean;
  useSalesforceChatNew: boolean;
  proScoreEnabled: boolean;
  proMonthlyBonusEnabled: boolean;
}

export const getFeatureFlags = createAsyncThunk(
  'settings/featureFlags/getAll',
  async (arg = undefined, api) => {
    const response = await makeRequest(
      `${FF_ENDPOINT}/`,
      {
        method: 'GET',
        configure: {
          withCredentials: false
        }
      }
    )(api);

    if (response.payload && ['400', '404', '502'].includes(response.payload.status.toString())) {
      return api.rejectWithValue({ error: getErrorMessage(response.payload) });
    }

    return response.data;
  }
);

// @ts-ignore
export const siteFeatureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState: {
    loaded: false,
    entities: {}
  } as {
    loaded: boolean;
    entities: FeatureFlags
  },
  extraReducers: builder => {
    builder.addCase(getFeatureFlags.fulfilled, (state, action) => {
      state.entities = action.payload;
      state.loaded = true;
    });
  }
});
